import {Component, OnInit} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';
import {MappingSystemUser2SORUserEntity, QARService, SORUserEntity} from '../services/qar.service';
import {Observable, of} from 'rxjs';
import {FormControl} from '@angular/forms';
import {debounceTime, map, startWith, switchMap} from 'rxjs/operators';

@Component({
	selector: 'app-page-sor-mapping',
	templateUrl: './sor-user-mapping.html',
	providers: [QARService]
})
export class SorUserMappingHomeComponent implements OnInit {


	constructor(public api: QARService) {
	}


	public ngOnInit(): void {
		this.aliases_init();
		this.systems_init();
	}

	// !ALERT
	modalAlert = {
		display: false,
		title: '',
		text: '', cb: (yesorno) => {
		}
	};

	public alert(text, title = 'Alert') {
		this.modalAlert.display = true;
		this.modalAlert.title = title;
		this.modalAlert.text = text;
		this.modalAlert.cb = (yesorno) => {
			this.modalAlert.display = false;
		};
	}

	public aliases_lookup(value: string): Observable<SORUserEntity[]> {
		if (typeof value === 'string') {
			return this.api.searchSORUser(value).pipe(
				// map the item property of the github results as our return object
				map(results => results)
			);
		} else {
			return new Observable<SORUserEntity[]>();
		}
	}

	autocompleteDisplayUser(w: SORUserEntity) {
		if (!w) {
			return '';
		}
		return w.FirstName + ' ' + w.LastName + ' ( ' + w.Login + ' )';
	}


	public aliases = {
		autocomplete$: null,
		loading: false,
		saving: false,
		deleting: {},
		newAlias: {
			sorUserIdFormControl: new FormControl(),
			systemId: null,
			username: null
		},
		chunker: (new Chunker([])),
		chunkedData: [],
		tableHeaders: [
			{id: 'System', label: 'System', filterable: true, idFunction: this.idFunctionSystem, sortable: true},
			{id: 'UserNameInSystem', label: 'Local Alias', filterable: true, sortable: true},
			{id: 'User', label: 'User', filterable: true, idFunction: this.idFunctionUser, sortable: true},
			{id: 'Action', label: ''}
		],
		tableOptions: {
			refreshButton: true,
			onRefreshContext: this,
			onRefreshFunction: () => {
				this.aliases_init();
			}
		}
	};

	idFunctionUser(w: MappingSystemUser2SORUserEntity) {
		return w.SORUser.FirstName + ' ' + w.SORUser.LastName;
	}

	idFunctionSystem(w) {
		return w['System']['Name'];
	}

	aliases_init() {
		this.aliases.loading = true;
		this.api.retrieveLocalAliasMappings().then(r => {
			this.aliases.loading = false;
			this.aliases.chunker = new Chunker(r);
		});

		this.aliases.autocomplete$ = this.aliases.newAlias.sorUserIdFormControl.valueChanges.pipe(
			startWith(''),
			// delay emits
			debounceTime(300),
			// use switch map so as to cancel previous subscribed events, before creating new once
			switchMap(value => {
				//if (value !== '') {
					return this.aliases_lookup(value);
				/*} else {
					// if no value is present, return null
					return of(null);
				}*/
			}));
	}

	aliases_delete(entry: MappingSystemUser2SORUserEntity) {
		const msg = 'Are you sure you want to delete this entry?';
		if (confirm(msg)) {
			this.aliases.deleting[entry.Id] = true;
			this.api.deleteLocalAliasMapping(entry).then(r => {
				this.aliases.deleting[entry.Id] = false;
				this.aliases_init();
			});
		}
	}

	aliases_save() {
		const systemId = parseInt(this.aliases.newAlias.systemId, 0);
		const username = this.aliases.newAlias.username;
		const sorUserId = this.aliases.newAlias.sorUserIdFormControl.value?.Id;

		if (!systemId) {
			this.alert('please select a system', 'Warning');
		} else if (!username || username.length < 2) {
			this.alert('please fill in the local alias', 'Warning');
		} else if (!sorUserId) {
			this.alert('please select a user', 'Warning');
		} else {
			this.aliases.saving = true;
			this.api.saveLocalAlias(systemId, username, sorUserId).then(r => {
				this.aliases.saving = false;
				this.aliases_init();
				this.aliases.newAlias.systemId = null;
				this.aliases.newAlias.username = null;
				this.aliases.newAlias.sorUserIdFormControl.setValue(null);

				this.alert('Local Alias Added', 'Success');
			}, e => {
				console.error('e', e.status);
				this.aliases.saving = false;
				if (e.status === 409) {
					this.alert('This user alias already exists for this system', 'Warning');
				} else {
					this.alert('Sorry, cannot save the new Local Alias', 'Warning');
				}
			});
		}
	}

	public systems = {
		loading: false,
		data: []
	};

	systems_init() {
		this.systems.loading = true;
		this.api.retrieveSystems().then(r => {
			this.systems.loading = false;
			this.systems.data = r;
		});
	}

}
